import styled from 'styled-components';

import { PADDING_CONTENT_PAGE, FONT_SIZE_LABEL } from '../../../globals';


export const StyledLabelStandart = styled.div`
  padding: 0px ${PADDING_CONTENT_PAGE}px 0px ${PADDING_CONTENT_PAGE}px;
  font-size: ${FONT_SIZE_LABEL}em;
  font-weight: 700;
`;
